import React, { useState, useEffect } from "react"
import { Modal }                      from "@shared/modal"
import WidgetSelector                 from "./widget_selector"

const DashboardModal = ({ 
  id,
  selectedWidgets = [],
  widgetTemplates = [], 
  onConfirm,
  isOpen,
  setIsOpen,
  extraButton,
  title,
  confirmText,
  dashboardTitle = ''
}) => {
  if (!widgetTemplates.length > 0) return

  useEffect(() => {
    if (isOpen) {
      setName(dashboardTitle)
      setSelected(selectedWidgets)
    }
  }, [isOpen])

  const [selected, setSelected] = useState([])
  const [name,     setName]     = useState(dashboardTitle)

  return (
    <Modal 
      id          = {id}
      isOpen      = {isOpen} 
      setIsOpen   = {setIsOpen} 
      title       = {title}
      size        = 'large'
      onConfirm   = {() => onConfirm(selected, name)}
      disabled    = {!selected.length || !name}
      confirmText = {confirmText} 
      extraButton = {extraButton}
    >
      <div className = "form-group">
        <label htmlFor = "dashboard-title">
          {I18n.t("export.dashboard_title")}
        </label>

        <input
          type        = "text"
          id          = "dashboard-title"
          className   = "form-control"
          value       = {name}
          onChange    = {e => setName(e.target.value)}
          placeholder = {I18n.t("export.dashboard_title_placeholder")}
        />
      </div>  

      <h5 className="py-3">{I18n.t("export.select_widgets")}</h5>

      <WidgetSelector
        widgetTemplates = {widgetTemplates}
        selected        = {selected}
        setSelected     = {setSelected}
      />
    </Modal>
  )
}

export default DashboardModal
